'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialUsageItem(secret, usage) {
  this.KB = null;
  this.KC = null;
  this.KB = secret;
  this.KC = usage;
}
export { $c_Lpresto_types$CredentialUsageItem as $c_Lpresto_types$CredentialUsageItem };
$p = $c_Lpresto_types$CredentialUsageItem.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialUsageItem;
/** @constructor */
function $h_Lpresto_types$CredentialUsageItem() {
}
export { $h_Lpresto_types$CredentialUsageItem as $h_Lpresto_types$CredentialUsageItem };
$h_Lpresto_types$CredentialUsageItem.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$CredentialUsageItem)) {
    var x = this.KB;
    var x$2 = x$0.KB;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.KC;
      var x$4 = x$0.KC;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "CredentialUsageItem";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.KB;
  }
  if ((n === 1)) {
    return this.KC;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$CredentialUsageItem(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jw)));
}
export { $isArrayOf_Lpresto_types$CredentialUsageItem as $isArrayOf_Lpresto_types$CredentialUsageItem };
var $d_Lpresto_types$CredentialUsageItem = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialUsageItem, "presto.types$CredentialUsageItem", ({
  jw: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$CredentialUsageItem as $d_Lpresto_types$CredentialUsageItem };
//# sourceMappingURL=presto.types$-Credential-Usage-Item.js.map
